import { Auth } from "../Auth";
import { LanguageService } from "../LanguageService";
import { Browser } from "./Browser";

export const CacheParam = {
  AUTH_STATUS: 'a',
  DEVICE_TYPE: 'd',
  LANGUAGE: 'l',
  PLATFORM: 'p'
};


const CahceHelper = {
  /**
   * Generates URL cache parameters based on provided config keys
   * @param {Array<string>} configKeys - An array of CacheConfig keys specifying which params to include
   * @returns {object} - Object with selected parameters and their values
   */
  getUrlCacheParams: (configKeys = [CacheParam.AUTH_STATUS, CacheParam.DEVICE_TYPE, CacheParam.LANGUAGE]) => {
    const params = {};
    configKeys.forEach((key) => {
      switch (key) {
        case CacheParam.AUTH_STATUS:
          params[CacheParam.AUTH_STATUS] = Auth.isAuthenticated();
          break;
        case CacheParam.DEVICE_TYPE:
          params[CacheParam.DEVICE_TYPE] = Browser.getHeaderDeviceType();
          break;
        case CacheParam.LANGUAGE:
          params[CacheParam.LANGUAGE] = LanguageService.getSelectedLanguage();
          break;
        case CacheParam.PLATFORM:
          const platform = Browser.getMobilePlatform();
          if (platform)
            params[CacheParam.PLATFORM] = Browser.getMobilePlatform();
        default:
          break;
      }
    });
    return params;
  },
  
  addCacheParam: (params, key) => {
    switch (key) {
      case CacheParam.AUTH_STATUS:
        params[CacheParam.AUTH_STATUS] = Auth.isAuthenticated();
        break;
      case CacheParam.DEVICE_TYPE:
        params[CacheParam.DEVICE_TYPE] = Browser.getHeaderDeviceType();
        break;
      case CacheParam.LANGUAGE:
        params[CacheParam.LANGUAGE] = LanguageService.getSelectedLanguage();
        break;
      case CacheParam.PLATFORM:
        const platform = Browser.getMobilePlatform();
        if (platform)
          params[CacheParam.PLATFORM] = Browser.getMobilePlatform();
      default:
        break;
    }
    return params;
  }
};

export default CahceHelper;

